// 信任与合规页面内容
import { APP_INFO } from '../app-info';

export const trustPages = {
  about: {
    h1: 'About Us',
    subtitle: 'Who we are and what this website provides for GB WhatsApp users.',
    badge: 'About',
    showDownload: false,
    sections: [
      {
        h2: 'What Is gbwhatts.net?',
        paragraphs: [
          'gbwhatts.net is an independent information and download resource for GB WhatsApp users. We help people find the latest APK, follow clear install and update guides, and troubleshoot common problems without wading through unreliable forum posts or sketchy download links.',
          'We are not affiliated with WhatsApp, Meta, or the developers of GB WhatsApp. Our role is to organize practical, honest content so you can make an informed decision about whether the mod fits your needs — not to sell you on features you do not need.',
        ],
      },
      {
        h2: 'What We Provide',
        list: [
          'Latest GB WhatsApp APK download links',
          'Step-by-step install and update guides',
          'Troubleshooting help for common problems',
          'Honest comparisons and safety information',
          'Trust and compliance pages for transparency',
        ],
      },
      {
        h2: 'Our Approach',
        paragraphs: [
          'We aim to give clear, honest information without pretending GB WhatsApp is risk-free or officially supported. Every page on this site is written to help you understand what you are getting into — the benefits, the trade-offs, and the steps to use the app responsibly.',
          'We encourage users to back up chats before installing, download only from trusted sources, and read our safety pages before putting an important phone number on any mod client. Good decisions start with accurate information, not marketing hype.',
        ],
      },
      {
        h2: 'Disclaimer',
        paragraphs: [
          'GB WhatsApp is a third-party modification, and you use it at your own risk. We are not responsible for account bans, data loss, or any other issues that may arise from using the app. For full legal details, read our <a href="/disclaimer/"><strong>disclaimer page</strong></a>.',
        ],
      },
    ],
  },

  disclaimer: {
    h1: 'Disclaimer',
    subtitle: 'Important information about this website and GB WhatsApp.',
    badge: 'Legal',
    showDownload: false,
    sections: [
      {
        h2: 'General Disclaimer',
        paragraphs: [
          'The information on gbwhatts.net is provided for general informational purposes only. We make no guarantees about the accuracy, completeness, or reliability of any content, and APK versions, features, and availability may change without notice.',
          'Any action you take based on information from this site is entirely at your own risk. We are not liable for any loss, damage, or inconvenience that results from downloading, installing, or using GB WhatsApp or any related software.',
        ],
      },
      {
        h2: 'Not Affiliated with WhatsApp or Meta',
        paragraphs: [
          'This website is not affiliated with, endorsed by, or connected to WhatsApp Inc., Meta Platforms Inc., or any official WhatsApp entity. GB WhatsApp is a third-party modified application that we do not develop, maintain, or control.',
          'WhatsApp and Meta are trademarks of their respective owners. We use the name GB WhatsApp solely to describe the mod application and help users find relevant information.',
        ],
      },
      {
        h2: 'No Safety Guarantees',
        paragraphs: [
          'We do not guarantee that GB WhatsApp is safe, virus-free, or free from account ban risk. Users should evaluate these risks independently before downloading or installing any third-party application.',
          'Download links on this site may point to third-party servers. We strive to use trusted sources, but we cannot control or verify external files after they leave our site.',
        ],
      },
      {
        h2: 'External Links',
        paragraphs: [
          'Our site may contain links to third-party websites for reference or convenience. We are not responsible for the content, privacy practices, or security of those external sites, and leaving gbwhatts.net via an external link is at your own discretion.',
        ],
      },
      {
        h2: 'Changes',
        paragraphs: [
          'We may update this disclaimer at any time without prior notice. Continued use of the site after changes are posted means you accept the current version. Check this page periodically if you want to stay informed about our terms.',
        ],
      },
    ],
  },

  privacy: {
    h1: 'Privacy Policy',
    subtitle: 'How we handle your information when you visit gbwhatts.net.',
    badge: 'Privacy',
    showDownload: false,
    sections: [
      {
        h2: 'Information We Collect',
        paragraphs: [
          'We collect minimal data when you visit our site. Basic analytics may include your browser type, device type, pages visited, and general location at the country level — nothing that identifies you personally.',
          'We do not require account registration, and we do not collect your phone number, contacts, or WhatsApp data. We also do not sell personal information to third parties.',
        ],
      },
      {
        h2: 'How We Use Information',
        list: [
          'To improve our website content and user experience',
          'To understand which pages are most helpful',
          'To respond to inquiries if you contact us by email',
          'To monitor site performance and fix broken pages',
        ],
      },
      {
        h2: 'Cookies',
        paragraphs: [
          'We may use cookies to remember preferences and analyze site traffic. Cookies are small files stored on your device that help us understand how visitors interact with the site.',
          'You can disable cookies in your browser settings at any time. Some site features may behave differently without cookies, but core content remains fully accessible.',
        ],
      },
      {
        h2: 'Third-Party Services',
        paragraphs: [
          'We may use third-party analytics tools to understand site traffic patterns. These services operate under their own privacy policies, which we encourage you to review independently.',
          'Our download links may redirect through third-party servers that host the APK files. We do not control their data practices, which is another reason we recommend scanning downloads before installing.',
        ],
      },
      {
        h2: 'Data Security',
        paragraphs: [
          'We take reasonable steps to protect the limited information we collect, but no method of internet transmission is completely secure. Do not send sensitive personal data through our contact email unless it is genuinely necessary.',
        ],
      },
      {
        h2: 'Contact',
        paragraphs: [
          'Questions about this policy? Visit our <a href="/contact/"><strong>contact page</strong></a> and we will do our best to respond within a few business days.',
        ],
      },
      {
        h2: 'Changes to This Policy',
        paragraphs: [
          'We may update this privacy policy from time to time. Changes will be posted on this page, and the date below reflects the most recent revision.',
          `Last updated: ${APP_INFO.updateMonth}.`,
        ],
      },
    ],
  },

  contact: {
    h1: 'Contact Us',
    subtitle: 'Get in touch with the gbwhatts.net team.',
    badge: 'Contact',
    showDownload: false,
    sections: [
      {
        h2: 'How to Reach Us',
        paragraphs: [
          'We welcome questions, feedback, and correction requests. If you find outdated version information, broken download links, or inaccurate content on any page, let us know so we can fix it.',
          'Email us at <strong>support@gbwhatts.net</strong> and include the page URL along with a short description of the issue. Screenshots help us diagnose and resolve problems faster.',
        ],
      },
      {
        h2: 'What We Can Help With',
        list: [
          'Website content questions',
          'Broken links or outdated version info',
          'General GB WhatsApp usage guidance',
          'Privacy or data-related inquiries',
          'Correction requests for inaccurate information',
        ],
      },
      {
        h2: 'What We Cannot Help With',
        list: [
          'Recovering banned WhatsApp accounts',
          'Technical support for the GB WhatsApp app itself',
          'Legal advice about mod app usage',
          'Official WhatsApp account or payment issues',
        ],
        paragraphs: [
          'For app-specific problems like install failures, connection issues, or OTP delays, check our <a href="/gb-whatsapp-not-installing/"><strong>troubleshooting pages</strong></a> — they cover the most common issues with step-by-step fixes.',
        ],
      },
      {
        h2: 'Response Time',
        paragraphs: [
          'We aim to respond within 2–3 business days. Including specific details about your issue — the page URL, your Android version, and what you already tried — helps us provide a useful answer rather than generic guidance.',
          'We may not respond to spam or promotional messages.',
        ],
      },
    ],
  },
};
